import { format, isToday, isYesterday, differenceInCalendarDays } from 'date-fns';

const groupNotificationsByDate = (notifications) => {
  const groups = {};

  for (const notification of notifications) {
    const dateObj = new Date(notification.created_at);
    let key = format(dateObj, 'yyyy-MM-dd');

    if (isToday(dateObj)) {
      key = 'Today';
    } else if (isYesterday(dateObj)) {
      key = 'Yesterday';
    } else {
      const daysAgo = differenceInCalendarDays(new Date(), dateObj);
      if (daysAgo <= 7) {
        key = 'Last Week';
      }
    }

    if (!groups[key]) groups[key] = [];
    groups[key].push(notification);
  }

  return groups;
};

export default groupNotificationsByDate;
